module.exports = __webpack_public_path__ + "static/media/flag-en.6e275976.webp";